import { request } from '../utils';
import getHeaders from './getHeaders';

export async function loadOwners({ projectId } = {}) {
  const url = '/projects/:projectId/hubspot/owners';

  return request({ method: 'get', url, urlParams: { projectId }, headers: getHeaders() });
}

export async function loadAssignedOwners({ projectId } = {}) {
  const url = '/projects/:projectId/hubspot/assigned_owners';

  return request({ method: 'get', url, urlParams: { projectId }, headers: getHeaders() });
}

export async function loadPipelines({ projectId } = {}) {
  const url = '/projects/:projectId/hubspot/pipelines';

  return request({ method: 'get', url, urlParams: { projectId }, headers: getHeaders() });
}

export async function loadTransferProperties({ projectId } = {}) {
  const url = '/projects/:projectId/hubspot/transfer/properties';

  return request({ method: 'get', url, urlParams: { projectId }, headers: getHeaders() });
}

export async function replaceAssignedOwners({ projectId }, { hubspot_ids }) {
  const url = '/projects/:projectId/hubspot/assigned_owners';

  return request({
    method: 'put',
    url,
    urlParams: { projectId },
    data: { hubspot_ids },
    headers: getHeaders(),
  });
}

export async function replaceHubspotUserPermissions({ projectId }, { user_ids }) {
  const url = '/projects/:projectId/hubspot/permissions';

  return request({
    method: 'put',
    url,
    urlParams: { projectId },
    data: { user_ids, project_id: projectId },
    headers: getHeaders(),
  });
}

export async function updateHubspotSettings({ projectId }, data) {
  const url = '/projects/:projectId/hubspot/settings';

  return request({
    method: 'put',
    url,
    urlParams: { projectId },
    data,
    headers: getHeaders(),
  });
}

export async function linkHubspotCompany({ projectId }, { lxpCompanyId, hsCompanyId }) {
  const url = '/projects/:projectId/hubspot/companies/link';

  return request({
    method: 'post',
    url,
    urlParams: { projectId },
    data: {
      project_id: projectId,
      company_id: lxpCompanyId,
      hs_company_id: hsCompanyId,
    },
    headers: getHeaders(),
  });
}

export async function createHubspotCompany({ projectId }, { lxpCompanyId, ownerId }) {
  const url = '/projects/:projectId/hubspot/companies';

  return request({
    method: 'post',
    url,
    urlParams: { projectId },
    data: {
      project_id: projectId,
      company_id: lxpCompanyId,
      hs_owner_id: ownerId,
    },
    headers: getHeaders(),
  });
}

export async function createHubspotTransfer({ projectId }, { hubspotTransfer }) {
  const url = '/projects/:projectId/hubspot/transfers';

  return request({
    method: 'post',
    url,
    urlParams: { projectId },
    data: hubspotTransfer,
    headers: getHeaders(),
  });
}

export async function findCompanyByName({ projectId }, { companyName }, requestConfig) {
  const url = '/projects/:projectId/hubspot/companies/search';

  return request({
    method: 'POST',
    url,
    urlParams: { projectId },
    data: { name: companyName },
    headers: getHeaders(),
    ...requestConfig,
  });
}


export async function loadHubspotTransfer({ projectId, hubspotTransferId }) {
  const url = '/projects/:projectId/hubspot/transfers/:hubspotTransferId';

  return request({
    method: 'GET',
    url,
    urlParams: { projectId, hubspotTransferId },
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/hubspot.js